export enum ELayout {
  BLANK = 'Blank',
  DEFAULT = 'Default',
  LOGIN = 'Login',
}
